<template>
	<el-dialog
		:visible.sync="visible"
		:show-close="false"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		class="role-dialog"
		width="350px"
	>
		<span slot="title" class="dialog-title">
			<span>新编号</span>
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<el-form :model="dataForm" :rules="dataRule" label-position="top" ref="dataForm">
			<el-form-item label="新编号" prop="partsNumberNew">
				<el-input v-model="dataForm.partsNumberNew" placeholder="请输入新编号"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button class="submit-btn" @click="submit">确定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from "@/utils/debounce";

export default {
	data() {
		return {
			visible: false,
			dataForm: {
                id: "",
				partsNumberNew: ""
			},
			dataRule: {
				partsNumberNew: [
					{
						required: true,
						message: "请输入新编号",
						trigger: "blur"
					}
				]
			}
		};
	},
	methods: {
		init(id) {
			this.visible = true;
			this.$nextTick(() => {
				this.$refs.dataForm.resetFields();
                this.dataForm.id = id;
			});
		},
		submit: debounce(function() {
			if (this.visible == false) {
				return;
			}
			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					let self = this;
                    self.visible = false;
					self.$request.post(`updatePartNumber`, true, self.dataForm, function(r) {
						if (r.code == "0") {
							self.$emit("refresh");
							self.$message.success("保存成功");
						} else {
							self.$message.error(r.msg);
						}
					});
				} else {
					return false;
				}
			});
		}, 1000)
	}
};
</script>
<style lang="scss" scoped>
.dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.el-form-item {
	margin-bottom: 10px;

	.el-select {
		width: 100%;
	}
}

.submit-btn {
	width: 100%;
	background-color: #117ffc;
	color: #fff;
}

.role-dialog /deep/ .el-dialog {
	border-radius: 10px !important;
}

.role-dialog /deep/ .el-dialog__body {
	padding: 0 20px !important;
}

.role-dialog /deep/ .el-form-item__label {
	padding: 0 !important;
}

.role-dialog /deep/ .el-dialog__footer {
	padding: 20px 20px 40px !important;
}
</style>
